/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanySubjectType {
    LEGAL_REPRESENTATIVE = 'LegalRepresentative',
    OWNER = 'Owner',
}
